import React, {Suspense, useEffect, useState} from 'react';
import {Layout, Menu, theme, message} from 'antd';
import {Link, Outlet, useNavigate, useLocation} from 'react-router-dom';
import Cookies from 'js-cookie';
import {UserOutlined} from '@ant-design/icons';
import Welcome from './Welcome';
import {menuName} from '../router'
import request from '../util/request'

const {Header, Sider, Content} = Layout;

const MainLayout = () => {
  const {token: { colorBgContainer }} = theme.useToken();
  const navigate = useNavigate();
  const location = useLocation();

  const [openKey, setOpenKey] = useState([]);
  const [selectedKey, setSelectedKey] = useState([]);

  const nickName = Cookies.get('CLS_SNAIL_CUSTOMER_CMS_NICKNAME');
  let menu = [];
  try {
    menu = Cookies.get('CLS_SNAIL_CUSTOMER_CMS_MENU') ? JSON.parse(Cookies.get('CLS_SNAIL_CUSTOMER_CMS_MENU')) : [];
  } catch(e) {
  }

  // 计算openKey和selsectedKey
  const pathname = location.pathname;
  useEffect(() => {
    if (!!pathname) {
      setSelectedKey(pathname);
      const menuKey = pathname.split('/');
      setOpenKey(!!menuKey[1] ? [`/${menuKey[1]}`] : []);
    }
  }, [pathname]);

  const showMenu = () => {
    return menu.map(item => {
      const childMenu = [];
      if (Array.isArray(item.children)) {
        item.children.forEach(childItem => {
          if (childItem.key !== 'edit') {
            childMenu.push({
              key: `/${item.key}/${childItem.key}`,
              label:<Link to={`/${item.key}/${childItem.key}`}>{
                childItem.key === 'new' ? `${menuName[childItem.key]}${menuName[item.key]}` : childItem.key === 'list' ? `${menuName[item.key]}${menuName[childItem.key]}` : menuName[childItem.key]
              }</Link>
            })
          }
        })
      }
      return {
        key: `/${item.key}`,
        icon: menuName[`${item.key}icon`],
        children: childMenu,
        label: menuName[item.key]
      }
    })
  };

  const handleLogout = () => {
    request({
      method: 'get',
      url: '/snailapi/auth/logout',
    }).then(response => {
      if (!!response && !!response.message) {
        message.success(response.message);
      }
      Cookies.remove('CLS_SNAIL_CUSTOMER_CMS_USERID');
      Cookies.remove('CLS_SNAIL_CUSTOMER_CMS_NICKNAME');
      Cookies.remove('CLS_SNAIL_CUSTOMER_CMS_PATH');
      Cookies.remove('snail_token');
      Cookies.remove('CLS_SNAIL_CUSTOMER_CMS_MENU');
      navigate('/login')
    }).catch(e => {
      message.error(e.message || '请求出错')
    })
  };

  return (
    <Layout className="mi-h-100v">
      <Sider
        className="sider"
        trigger={null}
        theme="dark"
        width={300}
        style={{
          position: 'fixed'
        }}
      >
        <div className="sider-logo-box">
          <img src="/snail-logo-2.png" />
        </div>
        <Menu
          className="h-100p o-a f-s-16 bg-c-2a2c3b main-menu"
          mode="inline"
          theme="dark"
          openKeys={openKey}
          selectedKeys={selectedKey}
          items={showMenu()}
          onOpenChange={(keys) =>{
            setOpenKey(keys)
          }}
        />
      </Sider>
      {
        menu.length > 0 ?
        <Layout className="content-layout">
          <Header className="d-f f-b-c o-a header" style={{ background: colorBgContainer }}>
            <div className="l-h-11">
              <div className="f-s-18 m-b-5">财联社-蜗牛</div>
              <div className="f-s-12">内容上传平台</div>
            </div>
            <div className="d-f">
              {
                !!nickName &&
                <>
                <UserOutlined className="m-r-10" />
                {nickName}
                </>
              }
              <div onClick={handleLogout} className="c-p"><span className="m-l-10 m-r-10">|</span>退出</div>
            </div>
          </Header>
          <Content className="content" style={{ background: colorBgContainer }}>
            <Suspense
              fallback={<div className="w-100p h-100p bg-c-fff">加载中...</div>}
            >
              <Outlet />
            </Suspense>
          </Content>
        </Layout> :
        <Welcome isLoadingWelcome={true}/>
      }
    </Layout>
  )
};

export default MainLayout;